<template>
  <div id="member-large" class="row">
    <div class="thumbnail-lg col-xl-3 col-lg-4 d-none d-lg-block">
      <img :src="member.photo" :alt="member.name + ' | Trilon Consulting'" />
    </div>
    <div class="member-description col-xl-9 col-lg-8">
      <a
        v-if="member.twitter"
        :href="'https://www.twitter.com/' + member.twitter"
        rel="noopener"
        target="_blank"
        class="trilon-pink twitter-link"
        >@{{ member.twitter }}</a
      >

      <a
        v-if="!member.twitter && member.social && member.social.length"
        :href="member.social[0].link"
        target="_blank"
        rel="noopener"
        >@{{ member.social[0].name }}</a
      >

      <h2>{{ member.name }}</h2>

      <p v-html="member.bio"></p>
      <div class="member-socials member-socials--lg">
        <a
          v-if="member.twitter"
          :href="'https://twitter.com/' + member.twitter"
          target="_blank"
        >
          <span class="fab fa-twitter"></span>
        </a>
        <a
          v-if="member.github"
          :href="'https://github.com/' + member.github"
          target="_blank"
        >
          <span class="fab fa-github"></span>
        </a>
        <a
          v-if="member.linkedin"
          :href="'https://www.linkedin.com/in/' + member.linkedin"
          target="_blank"
        >
          <span class="fab fa-linkedin"></span>
        </a>
        <!-- v-if="member.social" -->
        <a
          v-for="s in member.social"
          :key="s.id"
          :href="s.link"
          target="_blank"
        >
          <span :class="'fab ' + s.icon"></span>
        </a>
      </div>
    </div>
    <div
      class="videos-container col-12 align-items-center"
      v-if="member.videos && member.videos[0]"
    >
      <h3>{{ member.firstName }}'s Most Popular Lectures</h3>
      <div
        class="video-list-item row"
        v-for="video in member.videos"
        :key="video.id"
      >
        <div class="video cursor-pointer col-xl-3 col-md-4">
          <i class="fas fa-play"></i>
          <img
            @click="
              openLink('https://www.youtube.com/watch?v=' + video.youtubeId)
            "
            :src="video.thumbnail"
          />
        </div>
        <div class="video-description col-xl-9 col-md-8">
          <span>{{ video.conference }}</span>
          <a
            :href="'https://www.youtube.com/watch?v=' + video.youtubeId"
            v-html="video.talkName"
            target="_blank"
          ></a>
        </div>
      </div>
    </div>
    <div
      class="articles-container col-12"
      v-if="member.recentArticles && member.recentArticles.length > 0"
    >
      <h3>{{ member.firstName }}'s Recent Articles</h3>

      <div class="articles-list">
        <div
          class="article-item"
          v-for="article in member.recentArticles"
          :key="article.id"
        >
          <span class="article-date">{{ article.date }}</span>
          <h6>{{ article.pageTitle }}</h6>
          <!-- <p class="col-8">
            {{ article.description }}
          </!-->
          <a :href="article.link">Read the Article</a>
        </div>
      </div>
    </div>
    <div
      class="images-container videos-container col-12"
      v-if="member.images && member.images.length > 0"
    >
      <h3>{{ member.firstName }}'s Recent Work</h3>
      <div
        class="video-list-item row"
        v-for="video in member.images"
        :key="video.id"
      >
        <div class="video col-xl-3 col-md-4">
          <img :src="video.thumbnail" />
        </div>
        <div class="video-description col-xl-9 col-md-8">
          <span>{{ video.date }}</span>
          <a :href="video.url" target="_blank">{{ video.title }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    member: Object,
  },
  methods: {
    openLink(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss">
.member-details {
  text-align: left;
  padding-left: 4rem;

  @media (min-width: 1200px) {
    padding-right: 2rem;
  }

  @media (max-width: 1300px) {
    padding-left: 15px;
  }
}

.member-description {
  line-height: 1.7rem;
  padding-left: 3rem;

  @media (max-width: 1200px) {
    padding: 0 1rem;
  }
  h2 {
    font-weight: 600;
    margin: 0.9rem 0;
  }

  .twitter-link {
    font-weight: 500;
    font-size: 1.15rem;
  }
  .member-socials--lg {
    margin-top: 1.5rem;
    a {
      margin: 0 0.7rem;
      font-size: 1.5rem;
    }
  }
}

#member-large h3 {
  margin-bottom: 2.5rem;
  // border-bottom: 2px #505157 solid;
  padding-bottom: 1rem;
}

.videos-container {
  margin-top: 5rem;
  margin-bottom: 1rem;

  @media (max-width: 992px) {
    margin-top: 3rem;
    margin-bottom: 0;
  }

  .video {
    position: relative;

    &:hover {
      img {
        border-bottom: 5px #e91e63 solid;
      }
      i {
        opacity: 1;
      }
    }

    i {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0.5;
      font-size: 1rem;
    }

    img {
      height: auto;
      width: 100%;
      // max-width: 350px;
      margin-bottom: 2rem;
      border-bottom: 5px transparent solid;
    }
  }
  .video-description {
    a {
      color: #fff;
      font-weight: 500;
      font-size: 1.1rem;

      @media (max-width: 992px) {
        font-size: 1rem;
      }

      &:hover {
        color: #e91e63;
      }
    }
    span {
      color: #5f5f5f;
      font-size: 0.9rem;
      font-weight: 500;
      margin: 0.5rem 0 0.2rem;
      display: block;
    }
  }
}
.video-list-item {
  @media (max-width: 758px) {
    margin-bottom: 3rem;

    &:last-of-type {
      margin-bottom: 1rem;
    }
  }
}
.articles-container {
  margin: 2.5rem 0;
  width: 100%;
  max-width: 900px;
}
.article-item {
  border-bottom: 1px solid #242631;
  padding: 2rem 0;
  position: relative;

  a {
    position: absolute;
    right: 40px;
    top: 60%;
    transform: translateY(-50%);
  }

  h6 {
    line-height: 1.6rem;
  }

  @media (max-width: 1200px) {
    h6 {
      max-width: 400px;
    }
  }
  @media (max-width: 990px) {
    h6 {
      max-width: initial;
      margin: 0.5rem 0;
    }
    a {
      position: relative;
      transform: none;
      top: auto;
      right: auto;
    }
  }
}
.article-date {
  color: #5f5f5f;
  font-size: 0.9rem;
  font-weight: 500;
  margin: 0.5rem 0 0.2rem;
  display: block;
}
.images-container {
  .video {
    max-height: 120px;
    overflow: hidden;
  }
  .video-list-item {
    margin-bottom: 3rem;
  }
}
</style>
